import { gql } from 'apollo-angular';

const GET_RFP_DETAILS = gql`
  query getRfpDetails($rfpId: Long!) {
    rfp(id: $rfpId) {
      id
      hasPartialCategories
      spend {
        actualSpend
        continuedSpend
        annualizedSpend
      }
      potentialSavings {
        savingsVolume
      }
      statistics {
        sellerCount
        recipientCount
        participantCount
        systemCount
        leafCategoryCount
        productCount
        primaryCategoryCount
        recipientStatistics {
          leafCategoryCount
          primaryCategoryCount
        }
      }
      recipients {
        seller {
          id
          name
        }
      }
    }
  }
`;

export default GET_RFP_DETAILS;